import { CSSObject } from '@chakra-ui/react';

export const TextItem: CSSObject = {
  textTransform: 'uppercase',
  fontFamily: 'accent',
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'bold',
};
